import React, { useEffect, useRef, useState } from "react";
import DateConverter from "@heartinz/date_and_time_processor";
import "bootstrap-icons/font/bootstrap-icons.css";
import ReactPaginate from "react-paginate";
import Table from "../../../constants/Table";
import { useNetwork } from "../../../context/NetworkContext";
import AxiosInstance from "../../../utils/AxiosInstance";
import handleError from "../../../constants/handleError";
import { useShowAlert } from "../../../context/AlertContext";
import { useLocation, useNavigate } from "react-router-dom";
import CurrencyConverter from "@heartinz/currency_subunit_converter";
import { useAuth } from "../../../context/AuthProvider";
import PreSaleModeModal from "./ConfirmationPreSale";
import InvoiceTempPreview from "../settings/Invoice/InvoiceTempPreview";
import TemplateModalLayout from "../../../templates/modules/TemplateModalLayout";
import { usePermission } from "../../../context/PermissionContext";
import { formatCurrencyFun } from "../../../utils/formatCurrencyFunc";
import { AddIcon, RefreshIcon } from "../../../constants/Icons";

const ListPreSale = ({ isActive }) => {
  const { isUser, updateSettings } = useAuth();
  const navigate = useNavigate();
  const [isSearchTerm, setSearchTerm] = useState("");
  const containerRef = useRef(null);
  const [projects, setProjects] = useState([]);
  const debounceTimerRef = useRef(null);
  const controllerRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(-1);
  const [hasSearched, setHasSearched] = useState(false);
  const [ProductSuggestions, setProductSuggestions] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const searchInputRef = useRef(null);
  const suggestionRefs = useRef([]);
  const requestIdRef = useRef(0);
  const [isPreLoading, setPreLoading] = useState(false);

  const location = useLocation();
  const defaultMode =
    location.state?.mode || sessionStorage.getItem("presaleMode") || "proforma";

  const [status, setStatus] = useState(defaultMode);

  const [isModalOpen, setModalOpen] = useState(false);
  const [isEditData, setEditData] = useState(null);
  const [suggestionLoading, setSuggestionLoading] = useState(false);
  const [totalItems, setTotalItems] = useState(0);
  const [isBtnLoading, setBtnLoading] = useState({
    list: false,
    add: false,
  });
  const [buttonLoading, setButtonLoading] = useState({
    type: "",
    id: null,
  });
  const [isViewModalOpen, setViewModalOpen] = useState(false);
  const [isViewData, setViewData] = useState(null);
 const { storeSettings } =
    usePermission();
  const [selectedOption, setSelectedOption] = useState(
    "",
  );
   const templateId = storeSettings?.invoiceSettings?.template?.templateId;
  const [isViewTempModalOpen, setViewTempModalOpen] = useState(false);
  const [selectTermalOption, setSelectTermalOption] = useState("");

  const { checkNetwork } = useNetwork();
  const showAlert = useShowAlert();
  const perPage = 10;
  const handleOpenModal = () => {
    setModalOpen(true);
  };

  const openEditModal = (item) => {
    setEditData(item);
    setModalOpen(true);
  };

  const closeEditModal = () => {
    setModalOpen(false);
  };

  const handlePreSaleMode = (selectedMode) => {
    setModalOpen(false);

    navigate("/Proforma", {
      state: {
        mode: selectedMode,
      },
    });
  };

  const handleEdit = async (item) => {
    setButtonLoading({ type: "edit", id: item._id });

    try {
      const data = await handleSaleItems(item._id);

      if (data) {
        navigate("/editporforma", { state: data });
      }
    } catch (error) {
      console.error("Error loading sale data:", error);
    } finally {
      setButtonLoading({ type: "", id: null });
    }
  };

  const [jobcardsByStatus, setJobcardsByStatus] = useState({
    pending: [],
    inprogress: [],
    ready: [],
    delivered: [],
    cancelled: [],
  });

  const [jobcardCounts, setJobcardCounts] = useState({
    pending: 0,
    inprogress: 0,
    ready: 0,
    delivered: 0,
    cancelled: 0,
  });

  const handleSetTemplate = async (
    templateId,
    selectTermalOption,
    selectHalfA4Option,
    templateTheme,
    show = true,
  ) => {
    if (!checkNetwork()) return;
    try {
      const response = await AxiosInstance.patch(
        `module/storesettings/template`,
        {
          templateId: `${templateId}AND${selectTermalOption}AND${selectHalfA4Option}`,
          templateTheme,
        },
      );
      const results = response.data?.results?.invoiceSettings?.template;
      const id = results.templateId;
      const words = id.split("AND");
      setSelectedOption(words[0]);
      setSelectTermalOption(words[1]);
      setViewTempModalOpen(false);
      updateSettings({
        storeSettings: {
          invoiceSettings: {
            template: {
              templateId: results?.templateId,
              templateTheme: results?.templateTheme,
            },
            signature: results?.signature,
            termsAndConditions: results?.termsAndConditions,
          },
        },
      });
      {
        show && showAlert("success", "Template Selected...");
      }
    } catch (error) {
      handleError(error, showAlert);
    }
  };

  const handleSaleItems = async (saleId) => {
    try {
      if (!checkNetwork()) return;
      const response = await AxiosInstance.get(`module/presale/view/${saleId}`);
      return response.data.results;
    } catch (error) {
      handleError(error, showAlert);
      return null;
    }
  };

  const handleView = async (item) => {
    setButtonLoading({ type: "view", id: item._id });
    try {
      const data = await handleSaleItems(item._id);
      if (data) {
        setViewModalOpen(true);
        setViewTempModalOpen(true);
        setViewData(data);
      }
    } catch (error) {
      console.error("Error fetching view data:", error);
    } finally {
      setButtonLoading({ type: "", id: null });
    }
  };

  const handleClose = () => {
    setViewModalOpen(false);
    setViewData(null);
    // navigate(location.pathname, { replace: true, state: {} });
  };

  const openviewModal = (id) => {
    handleProjectView(id);
  };
  const openDeleteModal = (id) => {
    // if (window.confirm("Are you sure you want to delete this project?")) {
    //   setProjects((prev) => prev.filter((p) => p._id !== id));
    // }
  };

  const filteredProjects = projects.filter((item) => {
    if (status === "quotation") return item.preSaleMode === "QUOTATION";

    if (status === "estimation") return item.preSaleMode === "ESTIMATION";

    if (status === "proforma") return item.preSaleMode === "PROFORMA_INVOICE";

    return true;
  });

  const getCounts = (statusKey) =>
    projects.filter((p) => p.status === statusKey).length;

  useEffect(() => {
    const id =storeSettings?.invoiceSettings?.template?.templateId || "";
    const words = id ? id?.split("AND") : [];
    setSelectedOption(words[0]);
    setSelectTermalOption(words[1]);
  }, []);

  useEffect(() => {
    if (!isActive) return;
    const timer = setTimeout(() => {
      searchInputRef.current?.focus();
    }, 0);
    return () => clearTimeout(timer);
  }, [isActive]);

  const handleProjectList = async (page = 0, mode = status) => {
    setBtnLoading((prev) => ({ ...prev, list: true }));

    const modeMap = {
      quotation: "QUOTATION",
      estimation: "ESTIMATION",
      proforma: "PROFORMA_INVOICE",
    };

    try {
      if (!checkNetwork()) return;

      const response = await AxiosInstance.get(
        `module/presale/list?pageno=${page + 1}&limit=${perPage}&preSaleMode=${
          modeMap[mode] || ""
        }`,
      );

      setProjects(response.data.results || []);
      setTotalPages(response.data.totalPages || 0);
      setTotalItems(response.data.totalItems || 0);
    } catch (error) {
      handleError(error, showAlert);
    } finally {
      setBtnLoading((prev) => ({ ...prev, list: false }));
      setPreLoading(false);
    }
  };

  const handleProjectView = (id) => {
    navigate("/ViewProject", {
      state: { projectId: id },
    });
  };

  const handleRefresh = async () => {
    setPreLoading(true);

    try {
      await handleProjectList(currentPage);
    } finally {
      setPreLoading(false);
    }
  };
  const handleSearch = (term) => {
    const upperTerm = term.toLowerCase(); // ✅ Convert to uppercase
    setSearchTerm(upperTerm);
    setHasSearched(true);

    if (!upperTerm.trim()) {
      setProductSuggestions([]);
      setCurrentPage(0);
      return;
    }

    if (debounceTimerRef.current) {
      clearTimeout(debounceTimerRef.current);
    }
    if (controllerRef.current) {
      controllerRef.current.abort();
    }
    debounceTimerRef.current = setTimeout(async () => {
      try {
        if (!checkNetwork()) return;
        setSuggestionLoading(true);

        controllerRef.current = new AbortController();
        const currentId = ++requestIdRef.current;
        const response = await AxiosInstance.get(
          `module/project/search?searchtxt=${upperTerm}`,
          { signal: controllerRef.current.signal },
        );
        if (currentId === requestIdRef.current) {
          setProductSuggestions(response.data.results || []);
        }
      } catch (error) {
        if (error.name !== "CanceledError" && error.name !== "AbortError") {
          handleError(error, showAlert);
        }
      } finally {
        setSuggestionLoading(false);
      }
    }, 200);
  };
  const handleSuggestionNavigation = (e) => {
    if (e.key === "Enter") {
      if (activeIndex >= 0 && ProductSuggestions[activeIndex]) {
        e.preventDefault();
        openEditModal(ProductSuggestions[activeIndex]);
      }
      // else {
      //   e.preventDefault();
      //   handleSearchFind();
      // }
    } else if (e.key === "ArrowDown") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev < ProductSuggestions.length - 1 ? prev + 1 : 0,
      );
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setActiveIndex((prev) =>
        prev > 0 ? prev - 1 : ProductSuggestions.length - 1,
      );
    }
  };

  const getColor = (saleTrack, status) => {
    switch (saleTrack?.toUpperCase()) {
      case "CONVERTED":
        return "bg-label-primary"; 
      case "ADDED":
        return "bg-label-success"; // Green
      case "UPDATED":
        return "bg-label-warning"; // Yellow
      case "DELETED":
        return "bg-label-danger"; // Red
      case "RETURNED":
        return "bg-label-info"; // Blue
      default:
        switch (status?.toLowerCase()) {
          case "active":
            return "bg-label-success";
          case "cancelled":
            return "bg-label-danger";
          default:
            return "bg-label-secondary";
        }
    }
  };

  const formatTrackMode = (salemode) => {
    switch (salemode?.toUpperCase()) {
      case "QUOTATION":
        return "Quotation";
      case "ESTIMATION":
        return "Estimation";
      case "PROFORMA_INVOICE":
        return "Proforma";
      default:
        return salemode;
    }
  };

  const getBgTxtColor = (salemode) => {
    if (!salemode || typeof salemode !== "string") {
      return "bg-label-secondary";
    }

    switch (salemode.toUpperCase()) {
      case "QUOTATION":
        return "bg-label-wave";

      case "ESTIMATION":
        return "bg-label-deep-purple";

      case "PROFORMA_INVOICE":
        return "bg-label-orange";

      default:
        return "bg-label-secondary";
    }
  };

  const getBgColor = (salemode) => {
    if (!salemode || typeof salemode !== "string") {
      return "bg-label-secondary";
    }

    switch (salemode.toUpperCase()) {
      case "QUOTATION":
        return "bg-label-honey";

      case "ESTIMATION":
        return "bg-label-moon";

      case "PROFORMA_INVOICE":
        return "bg-label-info"; // or bg-label-success if you prefer

      default:
        return "bg-label-secondary";
    }
  };
  const getStatusLabel = (saleTrack, status) => {
    switch (saleTrack?.toUpperCase()) {
      case "CONVERTED":
        return "Converted";
      case "ADDED":
        return "Original";
      case "UPDATED":
        return "Modified";
      case "DELETED":
        return "Cancelled";
      case "RETURNED":
        return "Returned";
      default:
        return status?.charAt(0).toUpperCase() + status?.slice(1).toLowerCase();
    }
  };

  const handleTabChange = (mode) => {
    setStatus(mode);
    setCurrentPage(0);

    sessionStorage.setItem("presaleMode", mode);

    setPreLoading(true);
    handleProjectList(0, mode);
  };

  useEffect(() => {
    if (activeIndex >= 0 && suggestionRefs.current[activeIndex]) {
      suggestionRefs.current[activeIndex].scrollIntoView({
        behavior: "smooth",
        block: "nearest",
      });
    }
  }, [activeIndex]);

  useEffect(() => {
    if (location.pathname !== "/listpresale") return;

    const mode =
      location.state?.mode ||
      sessionStorage.getItem("presaleMode") ||
      "proforma";

    sessionStorage.setItem("presaleMode", mode);

    setStatus(mode);
    setCurrentPage(0);
    handleProjectList(0, mode);
  }, [location.pathname, location.state]);

  const modeLabel =
    {
      quotation: "Quotation",
      estimation: "Estimation",
      proforma: "Proforma",
    }[status] || "PreSale";

  return (
    <>
      <div>
        <div className="page-wrapper">
          <div className="page-content">
            <div className="row">
              <div className="breadcrumb-title pe-3 d-flex align-items-center gap-2">
                <div className="pb-1">
                  <button
                    type="button"
                    className="btn btn-sm btn-light p-1 shadow-none"
                    onClick={handleRefresh}
                    disabled={isPreLoading}
                    title="Refresh list"
                  >
                    <RefreshIcon iClass={`${isPreLoading ? "bx-spin" : ""}`}/>
                  </button>
                </div>
                <div className="breadcrumb-title pe-3">PreSale</div>
              </div>
            </div>

            <div className="card radius-10 mb-0 mt-2">
              <div className="row g-0">
                {/* Left Column Controls */}
                <div className="col-md-3 col-lg-2 border-end">
                  <div className="p-3">
                    <button
                      type="button"
                      onClick={handleOpenModal}
                      className="btn w-100 mb-3 btn-porforma"
                    >
                      <AddIcon iClass={"me-1"}/> New {modeLabel}
                    </button>

                    {[
                      {
                        key: "quotation",
                        label: "Quotation",
                        icon: "bx bx-notepad",
                        color: "btn-label-quotation",
                      },
                      {
                        key: "estimation",
                        label: "Estimation",
                        icon: "bi-calculator",
                        color: "bg-label-deep-purple",
                      },
                      {
                        key: "proforma",
                        label: "Proforma",
                        icon: "bi-receipt",
                        color: "bg-label-orange",
                      },
                    ].map((opt) => (
                      <button
                        key={opt.key}
                        className={`btn w-100 text text-start d-flex justify-content-between align-items-center mb-1
    ${status === opt.key ? opt.color + "" : "text-muted"}`}
                        onClick={() => handleTabChange(opt.key)}
                        style={{
                          border: "none",
                          boxShadow: "none",
                          transition: "background 0.2s ease",
                        }}
                      >
                        <span>
                          <i className={`${opt.icon} me-1`}></i> {opt.label}
                        </span>
                        {jobcardCounts[opt.key] > 0 &&
                          opt.key !== "delivered" &&
                          opt.key !== "cancelled" && (
                            <span
                              className={`badge rounded-pill bg-label-primary `}
                            >
                              {jobcardCounts[opt.key]}
                            </span>
                          )}
                      </button>
                    ))}
                  </div>
                </div>

                {/* Right Table Container Panel */}
                <div className="col-md-9 col-lg-10">
                  <div className="p-3">
                    {/* <div className="row">
                      <div className="col-lg-4 col-12 mb-2">
                        <div className="position-relative">
                          <div className="input-group">
                            <input
                              type="text"
                              className="form-control"
                              ref={searchInputRef}
                              value={isSearchTerm}
                              onChange={(e) => {
                                handleSearch(e.target.value);
                                setActiveIndex(-1);
                              }}
                              onKeyDown={handleSuggestionNavigation}
                              placeholder="Search Project ..."
                              autoFocus
                            />
                            <button className="input-group-text">
                              <i className="bx bx-search"></i>
                            </button>
                          </div>
                          {hasSearched &&
                            isSearchTerm &&
                            !suggestionLoading &&
                            ProductSuggestions.length === 0 && (
                              <ul className="suggestions-list">
                                <li className="suggestion-item text-muted">
                                  No Project data was found
                                </li>
                              </ul>
                            )}
                          {ProductSuggestions.length > 0 && (
                            <ul className="suggestions-list">
                              {ProductSuggestions.map((product, index) => (
                                <li
                                  key={product._id}
                                  ref={(el) =>
                                    (suggestionRefs.current[index] = el)
                                  }
                                  onClick={() => handleSuggestionClick(product)}
                                  // onClick={() => openEditModal(product)}
                                  className={`suggestion-item ${
                                    index === activeIndex
                                      ? "active-suggestion"
                                      : ""
                                  }`}
                                >
                                  <span className="text-black">
                                    {product.name}
                                  </span>
                                </li>
                              ))}
                            </ul>
                          )}
                        </div>
                      </div>
                    </div> */}

                    <div ref={containerRef}>
                      <Table
                        loading={isBtnLoading.list}
                        data={projects}
                        onRowClick={(item) => handleView(item)}
                        columns={[
                          // {
                          //   label: "S.No",
                          //   render: (_, index) => (
                          //     <>
                          //       {totalItems - (currentPage * perPage + index)}
                          //     </>
                          //   ),
                          // },
                          {
                            label: "PreSale Mode",
                            render: (item) =>
                              item.preSaleMode && (
                                <span
                                  className={`badge rounded-pill ${getBgColor(
                                    item.preSaleMode,
                                  )}`}
                                >
                                  {formatTrackMode(item.preSaleMode)}
                                </span>
                              ),
                          },
                          {
                            label: "PreSale No",
                            render: (item) =>
                              item.preSaleMode && (
                                <span
                                  className={`badge rounded-pill ${getBgTxtColor(
                                    item.preSaleMode,
                                  )}`}
                                >
                                  {item.preSaleNo}
                                </span>
                              ),
                          },
                          {
                            label: "PreSale Date",
                            render: (item) => (
                              <div className="d-flex flex-column">
                                <span className="text-nowrap text-heading fw-medium">
                                  {
                                    DateConverter.ISOToDisplayFormat(
                                      DateConverter.convertToTimeZone(
                                        item.preSaleUTCDate,
                                        isUser.timezone,
                                      ),
                                    ).date
                                  }
                                </span>
                                {/* <span className="text-nowrap">
                                                   <small>
                                                     {
                                                       DateConverter.ISOToDisplayFormat(
                                                         DateConverter.convertToTimeZone(
                                                           item.saledate,
                                                           isUser.timezone,
                                                         ),
                                                       ).time
                                                     }
                                                   </small>
                                                 </span> */}
                              </div>
                            ),
                          },
                          {
                            label: "PreSale To",
                            render: (item) => (
                              <div className="d-flex flex-column">
                                <span className="text-nowrap text-heading fw-medium">
                                  {item?.preSaleTo?.name
                                    ? `${item?.preSaleTo?.name}`
                                    : ""}
                                </span>
                                <span className="text-nowrap">
                                  <small>
                                    {item?.preSaleTo?.phone
                                      ? `+91 ${item?.preSaleTo.phone}`
                                      : " - "}
                                  </small>
                                </span>
                              </div>
                            ),
                          },
                          {
                            label: "PreSale Items",
                            render: (item) => (
                              <>{item?.totalItems || 0} Item(s)</>
                            ),
                          },
                          {
                            label: "Grand Total",
                            render: (item) => (
                              <span className="text-heading fw-medium text-truncate text-right">
                                {formatCurrencyFun(item?.grandTotal)}
                              </span>
                            ),
                          },
                          {
                            label: "Status",
                            render: (item) => (
                              <span
                                className={`badge rounded-pill ${getColor(
                                  item.preSaleTrack,
                                  item.status,
                                )}`}
                              >
                                {getStatusLabel(
                                  item?.preSaleTrack,
                                  item?.status,
                                )}
                              </span>
                            ),
                          },
                          // {
                          //   label: "Actions",
                          //   render: (item) => (
                          //     <div className="order-actions opacity-0 opacity-md-100">
                          //       {item?.status === "ACTIVE" &&
                          //         item?.saleTrack !== "RETURNED" && (
                          //           <button
                          //             type="button"
                          //             className="btn-label-primary shadow-none me-2"
                          //             onClick={(e) => {
                          //               e.stopPropagation();
                          //               handleEdit(item);
                          //             }}
                          //             disabled={
                          //               buttonLoading.id === item._id &&
                          //               buttonLoading.type === "edit"
                          //             }
                          //           >
                          //             {buttonLoading.id === item._id &&
                          //             buttonLoading.type === "edit" ? (
                          //               <CircularProgress
                          //                 size={20}
                          //                 className="text-primary"
                          //               />
                          //             ) : (
                          //               <i className="ng ng-ng-edit-icon"></i>
                          //             )}
                          //           </button>
                          //         )}
                          //     </div>
                          //   ),
                          // },
                        ]}
                      />
                    </div>
                    <div className="row align-items-center mt-3">
                      <div className="col text-center">
                        {totalPages > 0 && (
                          <ReactPaginate
                            previousLabel={"← Previous"}
                            nextLabel={"Next →"}
                            breakLabel={"..."}
                            onPageChange={({ selected }) => {
                              setCurrentPage(selected);
                              setPreLoading(true);
                              handleProjectList(selected, status);
                            }}
                            pageRangeDisplayed={5}
                            pageCount={totalPages}
                            containerClassName="pagination justify-content-center mb-0"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            activeClassName="active"
                            forcePage={currentPage}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* {isModalOpen && (
            <AddProject
              isActive={isActive}
              onClose={closeEditModal}
              setProjects={setProjects}
              editData={isEditData}
              setBtnLoading={setBtnLoading}
              isBtnLoading={isBtnLoading}
            />
          )} */}

          {!templateId && isViewTempModalOpen && (
            <InvoiceTempPreview
              isData={isViewData}
              onClose={() => setViewTempModalOpen(false)}
              onAdd={handleSetTemplate}
            />
          )}
           {templateId && isViewModalOpen && (
          <TemplateModalLayout
              isOpen={isViewModalOpen}
              isData={isViewData}
              onClose={handleClose}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              setSaleData={setViewData}
              isActive={isActive}
            />          
           )}
          {isModalOpen && (
            <PreSaleModeModal
              selectedMode={status}
              onClose={closeEditModal}
              onConfirm={handlePreSaleMode}
            />
          )}
        </div>
      </div>
    </>
  );
};

export default ListPreSale;
